import React, { useState } from 'react'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'

import ExpandMoreIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'

import { cn, parsedContent } from '@/lib/utils'

interface FAQItem {
  question: string
  answer: string[]
}

interface Props {
  faqs: FAQItem[]
  title?: string
  className?: string
  accordionWrClass?: string
}

export const RelatedFaq = ({
  title = 'Frequently Asked Questions (FAQs)',
  faqs,
  className,
  accordionWrClass
}: Props) => {
  const [expandedPanel, setExpandedPanel] = useState<string | null>(null)

  const handleChange = (panel: string) => (_: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setExpandedPanel(isExpanded ? panel : null)
  }

  const leftFaqs = faqs.slice(0, Math.ceil(faqs.length / 2))
  const rightFaqs = faqs.slice(Math.ceil(faqs.length / 2))

  return (
    <>
      <section className='general-faq-section admin-faq section-gap'>
        <div className='container'>
          <div className='section-title effect text-center justify-center flex'>
            <h2 className='capitalize inline-block clr-black'>{title}</h2>
          </div>
          <div className={cn('mt-6 md-mn:mt-10 grid lg-mn:grid-cols-2 lg-mn:gap-x-10', className)}>
            <div className={cn('space-y-2 lg-mn:space-y-4')}>
              {leftFaqs.map((faq, index) => (
                <div key={index} className={cn('[&_.MuiAccordion-root]:mb-0', accordionWrClass)}>
                  <Accordion expanded={expandedPanel === `panel${index}`} onChange={handleChange(`panel${index}`)}>
                    <AccordionSummary
                      className={'[&_.MuiAccordionSummary-content]:m-0'}
                      expandIcon={expandedPanel === `panel${index}` ? <RemoveCircleOutlineIcon /> : <ExpandMoreIcon />}
                    >
                      {parsedContent(faq.question).html}
                    </AccordionSummary>
                    <AccordionDetails className={'space-y-3'}>
                      {faq.answer.map((paragraph, idx) => (
                        <div key={idx} className={cn(parsedContent(paragraph).classes)}>
                          {parsedContent(paragraph).html}
                        </div>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                </div>
              ))}
            </div>
            <div className={cn('space-y-2 lg-mn:space-y-4')}>
              {rightFaqs.map((faq, index) => (
                <div key={index} className={cn('[&_.MuiAccordion-root]:mb-0', accordionWrClass)}>
                  <Accordion
                    expanded={expandedPanel === `panel${index + leftFaqs.length}`}
                    onChange={handleChange(`panel${index + leftFaqs.length}`)}
                  >
                    <AccordionSummary
                      className={'[&_.MuiAccordionSummary-content]:m-0'}
                      expandIcon={
                        expandedPanel === `panel${index + leftFaqs.length}` ? (
                          <RemoveCircleOutlineIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )
                      }
                    >
                      {parsedContent(faq.question).html}
                    </AccordionSummary>
                    <AccordionDetails className={'space-y-3'}>
                      {faq.answer.map((paragraph, idx) => (
                        <>
                          <div key={idx} className={cn(parsedContent(paragraph).classes)}>
                            {parsedContent(paragraph).html}
                          </div>
                        </>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
